import React from "react";
import {SearchForm} from "./searchForm"
import CustomerList from "./customerList"
const Customer = () => {
    return (
        <>
            <SearchForm/>
            <CustomerList/>
        </>
    )
}
export default Customer